















import { Component, Mixins } from "vue-property-decorator";
import { ISize } from "../../../../../../base/domain/drawing";
import { ImageAreaDrawableObjectDrawerBase } from "./base";
import { UploadImageFileMixin } from "../../mixins";
import { default as ImageRectangleCoordinatableObjectDrawer } from "./ImageRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    ImageRectangleCoordinatableObjectDrawer,
  },
})
export default class ImageAreaObjectDrawer extends Mixins(ImageAreaDrawableObjectDrawerBase, UploadImageFileMixin) {
  get displayName(): string {
    return this.isEnableImageSource
      ? " "
      : "画像エリア";
  }

  async uploadedImage(imageGuid: string, size: ISize<number>, fileName: string): Promise<void> {
    this.getCommonComponents().getOperators().getCurrentPage().deselectAllObjects();
    await this.$nextTick();
    this.addTemporaryImage(imageGuid, size);
    this.setImageContentProperty(imageGuid);
    this.select();
  }
}
